<template>
  <div class="container">
    <div class="goods">
      <RefundGoodsItem
        v-if="Object.keys(subOrderInfo).length > 0"
        :cart-info="subOrderInfo.cart_info"
      ></RefundGoodsItem>
    </div>
    <div class="form-group">
      <div class="form-item" v-if="type == 1" style="display:none;">
        <div class="title">货物状态</div>
        <div class="content radio-group">
          <div class="checkbox-wrapper">
            <label>
              <input
                name="status"
                type="radio"
                v-model="product_status"
                value="1"
              />
              <i class="icon"></i>
              <span class="radio-text">已收到货</span>
            </label>
          </div>
          <div class="checkbox-wrapper">
            <label>
              <input
                name="status"
                type="radio"
                v-model="product_status"
                value="0"
              />
              <i class="icon"></i>
              <span class="radio-text">未收到货</span>
            </label>
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="title">{{ typeShow }}原因</div>
        <div class="content">
          <span
            @click="showRefundReason"
            class="select-reason"
            :class="{ on: reason_content != '' }"
            >{{ reason_content == "" ? "请选择" : reason_content
            }}<img class="arrow" src="@images/arrow.png" alt=""
          /></span>
        </div>
      </div>
      <div class="form-item">
        <div class="title">{{ typeShow }}件数</div>
        <div class="content" v-if="type==3">
          <Counter
            v-if="Object.keys(subOrderInfo).length > 0"
            @changeNumber="handleChangeNumber"
            v-model="number"
            :max-num="max_num"
          ></Counter>
        </div>
        <div class="content" v-if="type!=3">{{number}}</div>
      </div>
    </div>
    <div
      class="form-group"
      v-if="Object.keys(addressInfo).length > 0 && type != 1"
    >
      <div class="form-item">
        <div class="title">收货地址：</div>
        <div class="content">
          <div class="address">
            <div class="name-phone">
              <div class="name">{{ addressInfo.real_name }}</div>
              <div class="phone">{{ addressInfo.user_phone }}</div>
            </div>
            <div class="address-detail line2">
              {{ addressInfo.user_address }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" v-if="type != 3">
      <div class="form-item">
        <div class="title">{{ typeShow }}金额：</div>
        <div class="content flex-start">￥{{ total_money_return }}</div>
      </div>
    </div>
    <div class="form-group" v-if="type != 3 && point_return>0">
      <div class="form-item">
        <div class="title">{{ typeShow }}购物券：</div>
        <div class="content flex-start">{{ point_return }}</div>
      </div>
    </div>

    <!--<div class="tips" v-if="type != 3">
      最多￥{{ maxRefundInfo.max_money_return }}，含发货邮费￥{{
        maxRefundInfo.pay_postage
      }}
    </div>-->
    <div class="form-group">
      <div class="form-item">
        <div class="title">{{ typeShow }}说明：</div>
        <div class="content">
          <input type="text" class="refund-desc" placeholder="选填" />
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-item column">
        <div class="title">上传凭证</div>
        <div class="content" style="margin-top: 0.2rem;">
          <div class="img-list">
            <div class="img-item" v-for="(item, index) in img_arr" :key="index">
              <img :src="item" alt="" />
              <div class="delete" @click="deleteImage(index)"></div>
            </div>
            <!--                        <div class="img-item">-->
            <!--                            <img src="http://oss.aizhongaiguoaimeng.com/0f3cf202004291559138809.jpg" alt="">-->
            <!--                        </div>-->
          </div>
          <UploadMultiple
            :multiple="true"
            :multipleSize="3 - img_arr.length"
            compress="80"
            class="upload-action"
            @imageuploaded="imageuploaded"
            @errorhandle="imageUploadErrorHandle"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            ref="upImg"
            v-if="img_arr.length < 3"
          >
            <img src="@images/upload-camera.png" alt="" />
            <div>
              <div>选填</div>
              <div>(最多3张)</div>
            </div>
          </UploadMultiple>
        </div>
      </div>
    </div>
    <div class="action-btn" :class="{ disable: !canSubmit }" @click="submit">
      提交
    </div>

    <ListPopUp
      ref="listPopUp"
      @select="handleSelected"
      :list="refundReasons"
      indexName="name"
      style-type="refund"
      :show-default-selectd="false"
      :show-close-btn="true"
    ></ListPopUp>
  </div>
</template>

<script>
import RefundGoodsItem from "@components/RefundGoodsItem";
import ListPopUp from "@components/ListPopUp";
import Counter from "@components/Counter";
// import VueCoreImageUpload from "vue-core-image-upload";
import {
  getBuyerAddress,
  getReturnProductInfo,
  getReturnReason,
  submitOrderReturn,
  getRefundMoney
} from "@api/user";
import { VUE_APP_API_URL } from "@utils/index";
import UploadMultiple from "@components/UploadMultiple";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import debounce from "lodash.debounce";
export default {
  name: "RefundForm",
  components: {
    RefundGoodsItem,
    ListPopUp,
    Counter,
    UploadMultiple
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      type: 0, // 售后类型 1-退款 2-退货退款 3-换货
      refundReasons: [],
      subOrderInfo: {}, //子订单信息
      product_status: 1, // 商品状态 1:已收货 0：未收货
      product_id: null, // 产品id
      oid: null,
      unique: null,
      reason_content: "", // 退款原因
      number: 1, // 退款数量
      total_money_return: 0, // 退款总额
      point_return: 0, // 退款总额
      remark: "", // 申请售后说明
      img_arr: [],
      img_str: "", // 图片地址
      addressInfo: {}, // 订单收货地址
      canSubmit: true
    };
  },
  mounted() {
    if (
      !this.$route.query.hasOwnProperty("type") ||
      !this.$route.query.hasOwnProperty("oid") ||
      !this.$route.query.hasOwnProperty("unique")
    ) {
      this.$dialog.error("参数异常");
      setTimeout(() => {
        this.$router.go(-1);
      });
    }
    this.cart_id = this.$route.query.cart_id;
    this.oid = this.$route.query.oid;
    this.unique = this.$route.query.unique;
    this.type = this.$route.query.type;
    this.$nextTick(() => {
      this.getReturnProductInfo();
      this.getReturnReason();
      this.getBuyerAddress();
    });
  },
  computed: {
    typeShow() {
      return this.type == 3 ? "换货" : "退款";
    }
  },
  methods: {
    showRefundReason() {
      this.$refs.listPopUp.open();
    },

    /**
     * 获取买家售后地址
     */
    getBuyerAddress() {
      getBuyerAddress({ oid: this.oid }).then(res => {
        this.addressInfo = res.data;
      });
    },
    /**
     * 处理计数器数值改变
     */
    handleChangeNumber: debounce(function(e) {
      console.log("计数器改变数值", e);
      this.canSubmit = true
      this.$nextTick(() => {
        this.calculateTotalMoney();
      });
    }, 500),
    /**
     * 计算退款金额
     */
    calculateTotalMoney() {
      getRefundMoney({
        num: this.number,
        oid: this.oid,
        unique: this.unique,
        type:this.type,
      })
        .then(res => {
          this.number = res.data.number;
          this.max_num = res.data.max_num;
          this.total_money_return = res.data.total_return;
          this.point_return = res.data.point_return;
        })
        .catch(err => {
          this.$dialog.error(err.msg);
          this.canSubmit = false;
        });
    },
    /**
     * 获取子订单信息
     */
    getReturnProductInfo() {
      let params = {
        oid: this.oid,
        unique: this.unique,
        cart_id: this.cart_id
      };
      getReturnProductInfo(params).then(res => {
        this.subOrderInfo = res.data;
        this.product_id = res.data.product_id;
        this.$nextTick(() => {
          this.calculateTotalMoney();
        });
      });
    },
    /**
     * 获取退款原因
     */
    getReturnReason() {
      getReturnReason().then(res => {
        res.data.forEach(item => {
          this.refundReasons.push({ name: item });
        });
      });
    },
    /**
     * 处理选择退款原因
     */
    handleSelected(e) {
      this.reason_content = e.name;
    },
    /**
     * 图片上传
     */
    imageuploaded(res) {
      console.log("上传成功", res);
      // if (res.status !== 200)
      //     return this.$dialog.error(res.msg || "上传图片失败");
      res.forEach(item => {
        this.img_arr.push(item.url);
      });
    },
    /**
     * 上传图片错误处理
     */
    imageUploadErrorHandle(errMsg) {
      this.$dialog.error(errMsg);
    },
    /**
     * 删除图片
     */
    deleteImage(index) {
      this.img_arr.splice(index, 1);
    },
    /**
     * 提交售后
     */
    async submit() {
      if (!this.canSubmit) {
        return false;
      }
      var {
        product_status,
        product_id,
        oid,
        unique,
        reason_content,
        number,
        total_money_return,
        remark,
        type
      } = this;
      console.log("货物状态", product_status, "商品ID", product_id);
      try {
        await this.$validator({
          reason_content: [required(required.message("退货原因"))]
        }).validate({ reason_content });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      let params = {
        product_status: product_status,
        product_id: product_id,
        oid: oid,
        unique: unique,
        reason_content: reason_content,
        num: number,
        total_money_return: total_money_return,
        remark: remark,
        img_str: this.img_arr.join(","),
        type: type
      };
      submitOrderReturn(params)
        .then(() => {
          this.$dialog.success("售后提交成功");
          this.$router.push("/user/refund_list");
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  margin-bottom: 1.7rem;
  .goods {
    background-color: #fff;
    padding: 0.2rem 0.32rem;
  }
  .tips {
    padding: 0.2rem 0.32rem 0 0.32rem;
    color: #999;
    font-size: 0.24rem;
  }
  .action-btn {
    position: fixed;
    bottom: 0.4rem;
    left: 50%;
    width: 7rem;
    height: 0.9rem;
    border-radius: 0.45rem;
    background-color: #ec5d59;
    text-align: center;
    line-height: 0.9rem;
    color: #ffffff;
    transform: translateX(-50%);
    &.disable {
      background-color: #ddd;
    }
  }

  .form-group {
    background-color: #fff;
    padding: 0.2rem 0.32rem;
    margin-top: 0.2rem;
    .form-item {
      display: flex;
      line-height:0.5rem;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 0.4rem;
      &.column {
        flex-direction: column;
        align-items: flex-start;
      }
      &:first-of-type {
        margin-top: 0;
      }
      .title {
        color: #333333;
        font-size: 0.28rem;
        text-align: left;
        font-weight: 400;
      }
      .content {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
        .select-reason {
          color: #999;
          font-size: 0.24rem;
          .arrow {
            margin-left: 0.2rem;
            width: 0.12rem;
          }
          &.on {
            color: #333;
          }
        }
        .refund-desc {
          width: 100%;
          line-height:0.5rem;
        }
        .img-list {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          .img-item {
            width: 2.16rem;
            height: 2.16rem;
            position: relative;
            margin-left: 0.2rem;
            border-radius: 0.6rem;
            &:first-of-type {
              margin-left: 0;
            }
            .delete {
              position: absolute;
              width: 0.4rem;
              height: 0.4rem;
              border-radius: 50%;
              background: rgba(0, 0, 0, 0.7) url("../../../assets/images/delete.png") no-repeat;
              background-size: 100%;
              color: #fff;
              top: -0.2rem;
              right: -0.2rem;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .upload-action {
          width: 2.16rem;
          height: 2.16rem;
          padding: 0.24rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          border: 1px dashed #979797;
          margin-left: 0.2rem;
          img {
            width: 0.96rem;
            height: 0.8rem;
          }
          div {
            text-align: center;
          }
        }
        .address {
          width: 100%;
          .name-phone {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        }
        &.radio-group {
          justify-content: space-around;
          .radio-text {
            font-size: 0.28rem;
            color: #282828;
            margin-left: 0.45rem;
          }
        }

        &.flex-start {
          justify-content: flex-start;
        }
      }
    }
  }
}
</style>
